// extracted by mini-css-extract-plugin
export default {"buttons":"ApprovalsTab_buttons__XBvQP"};